<template>
   <v-row>
        <v-col cols="6">
            <v-text-field
            v-model="nama_pic"
            @change="emitToParent()"
            :counter="50"
            label="Nama PIC"
            outlined
            ></v-text-field>

            <v-text-field
            v-model="job_title"
            @change="emitToParent()"
            :counter="100"
            label="Job Title"
            outlined
            ></v-text-field>

            <v-text-field
            v-model="email_pic"
            @change="emitToParent()"
            :counter="50"
            label="Email"
            outlined
            ></v-text-field>
            
        </v-col>

        <v-col cols="6">
            <v-text-field
            v-model="telephone_pic"
            @change="emitToParent()"
            :counter="20"
            label="Telephone"
            outlined
            ></v-text-field>

            <v-select
            v-model="active_pic"
            @change="emitToParent()"
            label="Active"
            :items="select_active"
            outlined
            ></v-select>
            
        </v-col>
    </v-row>
</template>
<script>
    /* eslint-disable */
import rules from "@/plugins/validation_rules.js";
let context;
export default{
    name:"vendor.pic.form",
    data:()=>{
        return{
            select_active:[
                {text:"Active",value:1},
                {text:"Disable",value:0}
            ],
            nama_pic:"",
            job_title:"",
            email_pic:"",
            telephone_pic:"",
            active_pic:1
        }
    },

    methods:{
        emitToParent(){
            let data ={
                nama_pic:context.nama_pic,
                job_title:context.job_title,
                email_pic:context.email_pic,
                telephone_pic:context.telephone_pic,
                active_pic:context.active_pic
            }

            context.$emit("change_value",data);
        }
    },
     async mounted(){
         context=this;
     }
}
</script>